/* jshint esversion: 6, -W097 */
/* globals require */
'use strict';

StoreLocatorService.$inject = [
    '$http',
    'UtilService',
    'GoogleApiService',
    'GeoService',
    'ProductApiConsumerService',
    'UtilitySelectorCookieService'
];
function StoreLocatorService(
    $http,
    UtilService,
    GoogleApiService,
    GeoService,
    ProductApiConsumerService,
    UtilitySelectorCookieService
) {
    var DEFAULT_ZIPCODE = 90291; // the default zipcode to be used if initial geoIP lookup fails
    var DEFAULT_COORDS = {'lat': 33.993396, 'long': -118.465193}; // the default coords to be used if initial geoIP lookup fails
    var GEOIP_KEY = UtilService.getSiteSetting('geoip_key', '');
    var GEOIP_URL = 'https://pro.ip-api.com/json/?key=' + GEOIP_KEY;
    var _pub = {};
    var _coordinates = {};
    var _zipcode;
    var _storeLocationData = {};
    var _productAvailabilityData = {};

    /**
     * Obtains user's coordinates and zipcode
     *  and uses default values if response
     * couldn't be obtained
     * @returns {*}
     */
    _pub.fetchLocationCoordinates = function () {
        return $http.get(GEOIP_URL)
            .then(function (response) {
                    _coordinates = {'lat': response.data.lat, 'long': response.data.lon};
                    _zipcode = response.data.zip;

                },
                function (error, status) {
                    var geoIpError = {message: error, status: status};
                    _coordinates = DEFAULT_COORDS;
                    _zipcode = DEFAULT_ZIPCODE;
                });
    };

    /**
     * Obtains user's coordinates from user's zipcode
     * and uses default values if response
     * couldn't be obtained
     * @param zipCode
     * @returns {*}
     */
    _pub.fetchLocationCoordinatesFromZipcode = function (zipCode) {
        return GeoService.getInfoFromZipcode(zipCode).then(function (latLngData) {
            if (!latLngData) {
                 return _pub.getLocationCoordinatesFromZipcodeGoogle(zipCode);
            } else {
                _coordinates = {
                    'lat': latLngData.lat,
                    'long': latLngData.lng
                };
                _zipcode = zipCode;
            }
        }, function () {
            return _pub.getLocationCoordinatesFromZipcodeGoogle(zipCode);
        });
    };
    /**
     * Obtains user's coordinates from user's zipcode from Google API
     * and uses default values if response
     * couldn't be obtained
     * @param zipCode
     * @returns {*}
     */
    _pub.getLocationCoordinatesFromZipcodeGoogle = function (zipCode) {
        return GoogleApiService.getInfoFromZipcode(zipCode).then(function (latLngData) {
            if (!latLngData) {
                _coordinates = DEFAULT_COORDS;
            } else {
                _coordinates = {
                    'lat': latLngData.lat,
                    'long': latLngData.lng
                };
            }
            _zipcode = zipCode;
        }, function () {
            _coordinates = DEFAULT_COORDS;
            _zipcode = DEFAULT_ZIPCODE;
        });
    };

    /**
     * Fetches location data for stores based on given parameters
     * @param latitude
     * @param longitude
     * @param zipcode
     * @param categoryId
     * @param productId
     * @returns {*}
     */
    _pub.fetchStoreLocationData = function (latitude, longitude, zipcode, categoryId, productId) {
        latitude = (typeof latitude === "undefined" ? DEFAULT_COORDS.lat : latitude);
        longitude = (typeof longitude === "undefined" ? DEFAULT_COORDS.long : longitude);

        var DEFAULT_RADIUS = 25;
        var settingsRadius = UtilService.getSiteSetting('store_locator_default_zoom_radius');
        var zoomRadius = settingsRadius !== undefined ? settingsRadius: DEFAULT_RADIUS;

        return ProductApiConsumerService.get('api/1.0/store-locator/', {
            params: {
                "lat": latitude,
                "lng": longitude,
                "zipcode": zipcode,
                "categoryId": categoryId,
                "productId": productId,
                "radius": zoomRadius
            }
        }).then(function (response) {
            _storeLocationData = response.data;
        }, function () {
            _storeLocationData = {};
        });
    };

    /**
     * Checks if given product is available based on given parameters
     * @param product_id
     * @param store_id
     * @param store_properties
     * @returns boolean in_stock value
     */
    _pub.checkProductInStoreAvailability = function (product_id, store_id, store_properties) {
        var store_string = store_properties.retailer_name + '|' +
            store_properties.address_details.address + '|' +
            store_properties.address_details.zipcode;

        return ProductApiConsumerService.get('search_store_availability/', {
            params: {
                "product_id": product_id,
                "store_id": store_id,
                "store": store_string
            }

        }).then(function (response) {
            _productAvailabilityData = response.data;
        }, function () {
            _productAvailabilityData = {};
        });
    };

    /**
     * Update _storeLocationData object after user performed
     * the search (in the search box)
     * @param latitude
     * @param longitude
     * @param productId
     * @returns {*}
     */
    _pub.updateStoreLocationData = function (latitude, longitude, productId) {
        latitude = (typeof latitude === "undefined" ? DEFAULT_COORDS.lat : latitude);
        longitude = (typeof longitude === "undefined" ? DEFAULT_COORDS.long : longitude);
        return ProductApiConsumerService.get('api/1.0/store-locator/', {
            params: {
                "lat": latitude,
                "lng": longitude,
                "productId": productId,
                "radius": 25
            }
        }).then(function (response) {
            _storeLocationData = response.data;
        }, function () {
            _storeLocationData = {};
        });
    };

    /**
     * Getter method for _storeLocationData
     */
    _pub.getStoreLocationData = function () {

        return _storeLocationData;

    };

    /**
     * Getter method for _coordinates
     */
    _pub.getCoordinates = function () {

        return _coordinates;

    };

    /**
     * Getter method for _zipcode
     */
    _pub.getZipcode = function () {

        return _zipcode;

    };

    /**
     * Getter method for _productAvailabilityData
     */
    _pub.getProductAvailabilityData = function () {

        return _productAvailabilityData;

    };

    /**
     * Fetches user location based on user selected utility zipcode,
     * obtained ipaddress, or default utility region.
     *
     * @returns {Object} - The promise to get the user coordinates
     */
    _pub.determineUserCoordinates = function() {
        var zipCode = UtilitySelectorCookieService.getUserZipCode();

        if (zipCode) {
            return _pub.fetchLocationCoordinatesFromZipcode(zipCode).then(function (data) {
                return {
                    'coordinates': _pub.getCoordinates(),
                    'zip_code': zipCode
                };
            });
        } else {
            return _pub.fetchLocationCoordinates().then(function () {
                return {
                    'coordinates': _pub.getCoordinates(),
                    'zip_code': _pub.getZipcode()
                };
            });
        }
    };

    return _pub;
}

module.exports = StoreLocatorService;
